import React from 'react'

import './styles.scss'
import { ButtonTag } from 'components/Form'
import { getButtonIconUrl, getButtonValue } from './utils'

const LookingForButton = ({ onlyTag, type, handleSearch }) => {
  return (
    <ButtonTag
      icon={
        <figure>
          <img src={getButtonIconUrl(type)} alt={type} />
        </figure>
      }
      value={getButtonValue(type)}
      onClick={() => typeof handleSearch === 'function'
        ? handleSearch({ type })
        : null
      }
      className={`
        looking-for-button__tag-btn
        ${onlyTag ? 'looking-for-button__tag-btn--only-tag' : ''}
      `}
    />
  )
}

export default LookingForButton
